<template>
  <Block
    label="หน่วยการเรียน Unit Outline"
    class="course-outline-units this-block"
    fit
  >
    <div slot="header" class="-header">
      <div class="--title">
        <span>หน่วยการเรียน Unit Outline</span>
      </div>

      <div class="--controllers">
        <vx-tooltip text="Add">
          <vs-button
            class="controller-buttons" radius color="gray" type="gradient" icon="plus_one"
            @click="$emit('call-editor', 'edit-unit', { mode: 'add', data: { courseOutlineId } })"
          />
        </vx-tooltip>

        <vx-tooltip text="Refresh">
          <vs-button
            class="controller-buttons"
            radius
            color="grey"
            type="gradient"
            icon="autorenew"
            @click="reloadData"
          />
        </vx-tooltip>
      </div>
    </div>

    <div class="-body">
      <vs-tabs class="--tabs">
        <template v-for="(unit, index) in units">
          <vs-tab class="-tab-container" :key="index" :label="(index + 1).toString()">
            <div class="-tab-content con-tab-ejemplo" v-if="unit">
              <div id="unit-info" class="--tab-content-left">
                <div class="block">
                  <div class="-header">
                    <div class="--title">
                      <span>หน่วยการเรียนที่ : {{ unit.seq }}</span>
                    </div>
                    <div class="--controllers">
                      <vx-tooltip text="Edit">
                        <vs-button
                          class="controller-buttons"
                          radius
                          color="gray"
                          type="gradient"
                          icon="edit"
                          @click="$emit('call-editor', 'edit-unit', { mode: 'edit', data: { courseOutlineId, ...unit } })"
                        />
                      </vx-tooltip>

                      <vx-tooltip text="Delete">
                        <vs-button
                          class="controller-buttons"
                          radius
                          color="grey"
                          type="gradient"
                          icon="delete_forever"
                          @click="deleteUnit(unit.id)"
                        />
                      </vx-tooltip>
                    </div>
                  </div>
                  <div class="-body">
                    <div>                    
                      ชื่อหัวข้อ: {{ unit.nameLocal }}
                    </div>

                    <div>                    
                      รายละเอียด: {{ unit.descriptionLocal }}
                    </div>
                  </div>
                </div>
              </div>

              <div id="unit-test">
                <div class="unit-pretest">
                  <div class="-card">
                    <div slot="header" class="-header">
                      <span>
                        คะแนน Pretest
                      </span>
                    </div>
                    <div class="-body">
                      <span>{{ unit.preTestExpectScore }}</span>
                    </div>
                  </div>
                </div>
                <div class="unit-posttest">
                  <div class="-card">
                    <div slot="header" class="-header">
                      <span>
                        คะแนน Posttest
                      </span>
                    </div>
                    <div class="-body">
                      <span>{{ unit.postTestExpectScore }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div id="unit-suppliments">
                <div class="unit-objective">
                  <div class="-title">
                    วัตถุประสงค์
                  </div>
                  <div class="-content">
                    {{ unit.unitObjective }}
                  </div>
                </div>
                <div class="unit-agenda">
                  <div class="-title">
                    สิ่งที่คาดหวัง
                  </div>
                  <div class="-content">
                    {{ unit.unitAgenda }}
                  </div>
                </div>
                <div class="unit-reference">
                  <div class="-title">
                    หนังสืออ้างอิง/อ่านเพิ่มเติม
                  </div>
                  <div class="-content">
                    {{ unit.unitReference }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="-tab-content _no-content">
              <h3>ยังไม่มีหน่วยการเรียนนี้</h3>  
              <vx-tooltip text="เพิ่มหน่วยการเรียนนี้">
                <vs-button
                  class=""
                  color="success"
                  size="large"
                  @click="$emit('call-editor', 'edit-unit', { mode: 'add', data: { courseOutlineId } })"
                >
                  <vs-icon 
                    icon="plus_one"
                  />
                  เพิ่ม
                </vs-button>
              </vx-tooltip>
            </div>
          </vs-tab>
        </template>
      </vs-tabs>
    </div>
  </Block>
</template>

<script>
import { Block } from "@/components/common-ui";
import { deleteCourseOutlineUnitById } from "@/services/api/course-outline";

export default {
  components: {
    Block
  },
  props: {
    units: Array,
    courseOutlineId: String,
    methods: Object
  },
  data() {
    return {
      textarea: ""
    }
  },
  methods: {
    reloadData() {
      if (this.methods) {
        if (Object.prototype.hasOwnProperty.call(this.methods, 'reloadData')) {
          this.methods.reloadData();
        }
      }
    },
    async deleteUnit(id) {
      const sure = confirm("ต้องการลบหน่วยการเรียนนี้ใช่หรือไม่?");
      if (sure) {
        await deleteCourseOutlineUnitById(id);
        this.methods.reloadData();
      }
    }
  }
}
</script>

<style lang="scss" scoped deep>
@import 'common-scoped';

.this-block {
}
</style>

<style lang="scss">
.--tabs {
  width: 100% !important;
  padding: 0 !important;

  & .con-ul-tabs {
    width: 100%;

    & > ul {
      display: inline-flex;
      justify-content: space-between;

      & > li {
        flex-grow: 1;
        height: 40px;
        // background: #eee;
        // border: 1px solid transparent;
        // border-bottom-color: #aaa;

        background: #ddd;
        box-shadow: 2px 0px 8px 0 rgba(0,0,0,0.12), 0 2px 8px 0 rgba(0,0,0,0.08) !important;
        border-bottom: 1px solid #d6cfcf;

        &.activeChild {
          // background: #ddd;
          // border-color: #aaa;
          // border-bottom-color: transparent;

          background: #eee;
          border-color: #dedede;
          border-bottom-color: transparent;
          box-shadow: 0 1px 2px 0 rgba(0,0,0,0.12), 0 2px 12px 0 rgba(0,0,0,0.08) !important;
              z-index: 1;
        }
      }
    }

    & .line-vs-tabs {
      opacity: 0.2;
    }
  }

  & .-tab-container {
    padding: 6px 4px;

    & .-tab-content {
      display: flex;
      flex-direction: column;
      display: grid;
      // grid-template-columns: repeat(3, 1fr);
      grid-template-columns: 5px 1fr 20px 1fr 20px 1fr 5px;
      grid-template-rows: 5px 300px 20px 200px 5px;

      & .--row {
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
      }

      &._no-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        min-height: 300px;

        & button {
          margin-top: 20px;
        }

        & span {
          text-align: center;
        }
      }
    }
  }
}

#unit-info {
  // flex-grow: 3;
  // margin-right: 10px;
  // height: 260px;
  grid-column: 2 / span 3;
  grid-row: 2 / 3;
  box-shadow: 0 1px 10px 0 rgba(0,0,0,.1);

  & .block {
    height: calc(100% - 50px);

    & .-header {
      // background: #add8ce;
      // background: #100e52;
      background: #504f6b;
      padding: 8px;
      // height: 2.6rem;
      display: inline-flex;
      justify-content: space-between;
      width: 100%;

      & .--controllers {
        & button {
          width: 20px;
          height: 20px;
          margin: 2px;
        }
      }
    }

    & .-body {
      // border: 1px solid #add8ce;
      // border: 1px solid #100e52;
      padding: 8px;
    }
  }
}

#unit-test {
  grid-column: 6/7;
  grid-row: 2;
  height: 100%;
  display: flex;
  flex-direction: column;

  // flex-grow: 1;
  // flex-shrink: 0;
  // display: inline-flex;
  // max-width: 420px;
  // padding: 0 4rem;

  & > div {
    flex-grow: 1;
    // height: calc(50%);
    height: auto;
    // margin-bottom: 10px;
    box-shadow: 0 1px 10px 0 rgba(0,0,0,.1);


    &:not(:first-child) {
      margin-top: 20px;
    }

    & > div {
      height: 100%;
    }
  }

  & .-header {
    // background: #324f6f;
    background: #eeeeee;
    border-bottom: 1px solid #cccccc80;
    color: black;
    padding: 8px;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    letter-spacing: 0.3px;
  }

  & .-body {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    height: calc(100% - 50px);
  }
}

#unit-suppliments {
  grid-row: 4;
  grid-column: 2 / 7;
  display: inline-flex;
  justify-content: space-around;
  width: 100%;
  height: 200px;

  & > div {
    height: 200px;
    border: 1px solid #ddd;
    // background: #f3e5c4;
    background: #eeeeee;
    box-shadow: 0 1px 10px 0 rgba(0,0,0,.1);
    width: 100%;
    border-radius: 6px;

    &:not(:first-child) {
      margin-left: 20px;
    }
  }

  & .-title {
    // background: #100e52;
    // background: #504f6b;
    background: #c3c3c3;
    // color: white;
    color: black;
    padding: 8px;
    border-radius: 6px 6px 0 0;
    border-bottom: 1px solid #bbbbbb80;
    // margin-bottom: 8px;
    padding-bottom: 4px;
    font-size: 1rem;
    font-weight: 200;
    letter-spacing: 0.3px;
  }

  & .-content {
    font-size: 0.9rem;
    padding: 8px;
  }
}
</style>
